module.exports = __webpack_public_path__ + "img/pvc_sluitprofiel.fdabb0bc.jpg";